const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins
const { breakpoints } = window.BAO.MediaBreakpoints

class CtaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    const disabled = this.els.slide.elements.length < 4

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.7,
          spacing: 1,
        },
        breakpoints: {
          [`(min-width: ${breakpoints.sm}px)`]: {
            disabled,
            slides: {
              perView: 3,
              spacing: 1,
            },
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('cta-carousel')) {
  customElements.define('cta-carousel', CtaCarousel)
}
